@switch ($safeNavigationMigration(settings?.drawerDetails?.layout())) {
  @case (FeatureMasterViewDrawerDetailsLayout.GRID) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="sectionHeader" />

      <div class="feature-master-view" data-cy="feature-master-view" fxFlex fxLayout="column">
        <div class="sticky">
          <ng-container *ngTemplateOutlet="toolbar" />
          <ng-container *ngTemplateOutlet="filterEngine" />
        </div>

        <div class="feature-master-view__engine-container" fxFlex>
          <mat-sidenav-container
            class="feature-master-view__drawer-container"
            [hasBackdrop]="$safeNavigationMigration(settings?.drawerDetails?.hasBackdrop())"
            (backdropClick)="onBackdropClick()"
          >
            <mat-sidenav-content fxLayout="column" [style.width]="settings?.drawerDetails?.mode() === 'over' ? 'auto' : sideNavContentWidth()">
              <ng-container *ngTemplateOutlet="pageContent" />
            </mat-sidenav-content>
            <mat-sidenav
              #sidenav
              [disableClose]="settings?.drawerDetails?.closeOnBackdropClick && !settings?.drawerDetails?.closeOnBackdropClick?.()"
              [mode]="isXSmallScreen() ? 'over' : $safeNavigationMigration(settings?.drawerDetails?.mode())"
              [opened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
              [position]="settings?.drawerDetails?.position() || 'start'"
              [style.width]="drawerWidth()"
            >
              <ng-container *ngTemplateOutlet="drawerDetails" />

              @if (settings?.drawerDetails?.resizable?.()) {
                <iot-platform-ui-resize-handle
                  [parentContainerSelector]="'.feature-master-view__engine-container'"
                  [pageName]="$safeNavigationMigration(settings?.masterViewName?.())"
                  [defaultWidth]="$safeNavigationMigration(settings?.drawerDetails?.width?.())"
                  [minWidth]="$safeNavigationMigration(settings?.drawerDetails?.minWidth?.())"
                  [maxWidth]="$safeNavigationMigration(settings?.drawerDetails?.maxWidth?.())"
                  [resizable]="$safeNavigationMigration(settings?.drawerDetails?.resizable?.())"
                  [position]="$safeNavigationMigration(settings?.drawerDetails?.position?.())"
                  [resizeElementOpened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
                  (contentWidth)="sideNavContentWidth.set($event)"
                  (width)="drawerWidth.set($event)"
                />
              }
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </div>
  }
  @case (FeatureMasterViewDrawerDetailsLayout.FILTER_ENGINE) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="sectionHeader" />

      <div class="feature-master-view" data-cy="feature-master-view" fxFlex fxLayout="column">
        <div class="sticky">
          <ng-container *ngTemplateOutlet="toolbar" />
        </div>

        <div class="feature-master-view__engine-container" fxFlex>
          <mat-sidenav-container
            class="feature-master-view__drawer-container"
            [hasBackdrop]="$safeNavigationMigration(settings?.drawerDetails?.hasBackdrop())"
            (backdropClick)="onBackdropClick()"
          >
            <mat-sidenav-content fxLayout="column" [style.width]="settings?.drawerDetails?.mode() === 'over' ? 'auto' : sideNavContentWidth()">
              <ng-container *ngTemplateOutlet="filterEngine" />
              <ng-container *ngTemplateOutlet="pageContent" />
            </mat-sidenav-content>
            <mat-sidenav
              #sidenav
              [disableClose]="settings?.drawerDetails?.closeOnBackdropClick && !settings?.drawerDetails?.closeOnBackdropClick?.()"
              [mode]="isXSmallScreen() ? 'over' : $safeNavigationMigration(settings?.drawerDetails?.mode())"
              [opened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
              [position]="settings?.drawerDetails?.position() || 'start'"
              [style.width]="drawerWidth()"
            >
              <ng-container *ngTemplateOutlet="drawerDetails" />

              @if (settings?.drawerDetails?.resizable?.()) {
                <iot-platform-ui-resize-handle
                  [parentContainerSelector]="'.feature-master-view__engine-container'"
                  [pageName]="$safeNavigationMigration(settings?.masterViewName?.())"
                  [defaultWidth]="$safeNavigationMigration(settings?.drawerDetails?.width?.())"
                  [minWidth]="$safeNavigationMigration(settings?.drawerDetails?.minWidth?.())"
                  [maxWidth]="$safeNavigationMigration(settings?.drawerDetails?.maxWidth?.())"
                  [resizable]="$safeNavigationMigration(settings?.drawerDetails?.resizable?.())"
                  [position]="$safeNavigationMigration(settings?.drawerDetails?.position?.())"
                  [resizeElementOpened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
                  (contentWidth)="sideNavContentWidth.set($event)"
                  (width)="drawerWidth.set($event)"
                />
              }
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </div>
  }
  @case (FeatureMasterViewDrawerDetailsLayout.TOOLBAR) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="sectionHeader" />

      <div class="feature-master-view" data-cy="feature-master-view" fxFlex fxLayout="column">
        <div class="sticky"></div>

        <div class="feature-master-view__engine-container" fxFlex>
          <mat-sidenav-container
            class="feature-master-view__drawer-container"
            [hasBackdrop]="$safeNavigationMigration(settings?.drawerDetails?.hasBackdrop?.())"
            (backdropClick)="onBackdropClick($event)"
          >
            <mat-sidenav-content fxLayout="column" [style.width]="settings?.drawerDetails?.mode() === 'over' ? 'auto' : sideNavContentWidth()">
              <ng-container *ngTemplateOutlet="toolbar" />
              <ng-container *ngTemplateOutlet="filterEngine" />
              <ng-container *ngTemplateOutlet="pageContent" />
            </mat-sidenav-content>
            <mat-sidenav
              #sidenav
              [disableClose]="settings?.drawerDetails?.closeOnBackdropClick && !settings?.drawerDetails?.closeOnBackdropClick?.()"
              [mode]="isXSmallScreen() ? 'over' : $safeNavigationMigration(settings?.drawerDetails?.mode())"
              [opened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
              [position]="settings?.drawerDetails?.position() || 'start'"
              [style.width]="drawerWidth()"
            >
              <ng-container *ngTemplateOutlet="drawerDetails" />

              @if (settings?.drawerDetails?.resizable?.()) {
                <iot-platform-ui-resize-handle
                  [parentContainerSelector]="'.feature-master-view__engine-container'"
                  [pageName]="$safeNavigationMigration(settings?.masterViewName?.())"
                  [defaultWidth]="$safeNavigationMigration(settings?.drawerDetails?.width?.())"
                  [minWidth]="$safeNavigationMigration(settings?.drawerDetails?.minWidth?.())"
                  [maxWidth]="$safeNavigationMigration(settings?.drawerDetails?.maxWidth?.())"
                  [resizable]="$safeNavigationMigration(settings?.drawerDetails?.resizable?.())"
                  [position]="$safeNavigationMigration(settings?.drawerDetails?.position?.())"
                  [resizeElementOpened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
                  (contentWidth)="sideNavContentWidth.set($event)"
                  (width)="drawerWidth.set($event)"
                />
              }
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </div>
  }
  @case (FeatureMasterViewDrawerDetailsLayout.ALL) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <div class="feature-master-view" data-cy="feature-master-view" fxFlex fxLayout="column">
        <div class="sticky"></div>

        <div class="feature-master-view__engine-container" fxFlex>
          <mat-sidenav-container
            class="feature-master-view__drawer-container"
            [hasBackdrop]="$safeNavigationMigration(settings?.drawerDetails?.hasBackdrop())"
            (backdropClick)="onBackdropClick()"
          >
            <mat-sidenav-content fxLayout="column" [style.width]="settings?.drawerDetails?.mode() === 'over' ? 'auto' : sideNavContentWidth()">
              <ng-container *ngTemplateOutlet="sectionHeader" />
              <ng-container *ngTemplateOutlet="toolbar" />
              <ng-container *ngTemplateOutlet="filterEngine" />
              <ng-container *ngTemplateOutlet="pageContent" />
            </mat-sidenav-content>
            <mat-sidenav
              #sidenav
              [disableClose]="settings?.drawerDetails?.closeOnBackdropClick && !settings?.drawerDetails?.closeOnBackdropClick?.()"
              [mode]="isXSmallScreen() ? 'over' : $safeNavigationMigration(settings?.drawerDetails?.mode())"
              [opened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
              [position]="settings?.drawerDetails?.position() || 'start'"
              [style.width]="drawerWidth()"
            >
              <ng-container *ngTemplateOutlet="drawerDetails" />

              @if (settings?.drawerDetails?.resizable?.()) {
                <iot-platform-ui-resize-handle
                  [parentContainerSelector]="'.feature-master-view__engine-container'"
                  [pageName]="$safeNavigationMigration(settings?.masterViewName?.())"
                  [defaultWidth]="$safeNavigationMigration(settings?.drawerDetails?.width?.())"
                  [minWidth]="$safeNavigationMigration(settings?.drawerDetails?.minWidth?.())"
                  [maxWidth]="$safeNavigationMigration(settings?.drawerDetails?.maxWidth?.())"
                  [resizable]="$safeNavigationMigration(settings?.drawerDetails?.resizable?.())"
                  [position]="$safeNavigationMigration(settings?.drawerDetails?.position?.())"
                  [resizeElementOpened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
                  (contentWidth)="sideNavContentWidth.set($event)"
                  (width)="drawerWidth.set($event)"
                />
              }
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </div>
  }
  @default {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="sectionHeader" />

      <div class="feature-master-view" data-cy="feature-master-view" fxFlex fxLayout="column">
        <div class="sticky">
          <ng-container *ngTemplateOutlet="toolbar" />
          <ng-container *ngTemplateOutlet="filterEngine" />
        </div>

        <div class="feature-master-view__engine-container" fxFlex>
          <mat-sidenav-container
            class="feature-master-view__drawer-container"
            [hasBackdrop]="$safeNavigationMigration(settings?.drawerDetails?.hasBackdrop())"
            (backdropClick)="onBackdropClick()"
          >
            <mat-sidenav-content fxLayout="column" [style.width]="settings?.drawerDetails?.mode() === 'over' ? 'auto' : sideNavContentWidth()">
              <ng-container *ngTemplateOutlet="pageContent" />
            </mat-sidenav-content>
            <mat-sidenav
              #sidenav
              [disableClose]="settings?.drawerDetails?.closeOnBackdropClick && !settings?.drawerDetails?.closeOnBackdropClick?.()"
              [mode]="isXSmallScreen() ? 'over' : $safeNavigationMigration(settings?.drawerDetails?.mode())"
              [opened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
              [position]="settings?.drawerDetails?.position() || 'start'"
              [style.width]="drawerWidth()"
            >
              <ng-container *ngTemplateOutlet="drawerDetails" />

              @if (settings?.drawerDetails?.resizable?.()) {
                <iot-platform-ui-resize-handle
                  [parentContainerSelector]="'.feature-master-view__engine-container'"
                  [pageName]="$safeNavigationMigration(settings?.masterViewName?.())"
                  [defaultWidth]="$safeNavigationMigration(settings?.drawerDetails?.width?.())"
                  [minWidth]="$safeNavigationMigration(settings?.drawerDetails?.minWidth?.())"
                  [maxWidth]="$safeNavigationMigration(settings?.drawerDetails?.maxWidth?.())"
                  [resizable]="$safeNavigationMigration(settings?.drawerDetails?.resizable?.())"
                  [position]="$safeNavigationMigration(settings?.drawerDetails?.position?.())"
                  [resizeElementOpened]="$safeNavigationMigration(settings?.drawerDetails?.opened())"
                  (contentWidth)="sideNavContentWidth.set($event)"
                  (width)="drawerWidth.set($event)"
                />
              }
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </div>
  }
}

<ng-template #sectionHeader>
  @if (settings?.sectionHeader?.enabled?.()) {
    <iot-platform-ui-section-header
      (dispatchEvent)="onMasterViewEngineEvent($event)"
      [actions]="$safeNavigationMigration(settings?.sectionHeader?.actions)"
      [cssClassName]="$safeNavigationMigration(settings?.sectionHeader?.cssClassName?.())"
      [icon]="$safeNavigationMigration(settings?.sectionHeader?.icon?.())"
      [styles]="$safeNavigationMigration(settings?.sectionHeader?.styles?.())"
      [svgIcon]="$safeNavigationMigration(settings?.sectionHeader?.svgIcon?.())"
      [title]="$safeNavigationMigration(settings?.sectionHeader?.title?.()) | translate"
    />
  }
</ng-template>

<ng-template #toolbar>
  @if (settings?.toolbar?.enabled()) {
    <iot-platform-ui-toolbar-v2
      data-cy="feature-master-view-toolbar"
      (dispatchToolbarEvent)="onToolbarEvent($event)"
      [autoRefresh]="{
        counter: 100 - (timer() / $safeNavigationMigration(grid()?.gridOptions?.autoRefresh?.delay)) * 100,
        timeLeft: $safeNavigationMigration(grid()?.gridOptions?.autoRefresh?.delay) - timer(),
        displaySpinner: $safeNavigationMigration(grid()?.gridOptions?.autoRefresh?.enabled)
      }"
      [buttonList]="toolbarButtonList()"
      [withFavoriteViews]="$safeNavigationMigration(settings?.toolbar?.withFavoriteViews?.())"
      [withGrids]="$safeNavigationMigration(settings?.toolbar?.withGrids?.())"
      [dashboardsConfiguration]="$safeNavigationMigration(dashboardsConfiguration?.())"
      [favoriteViewConfiguration]="favoriteViewsConfiguration()"
      [gridsConfiguration]="gridsConfiguration()"
      [isDataLoaded]="loaded()"
      [name]="$safeNavigationMigration(settings?.toolbar?.toolbarName()) | translate"
      [pageTypeOptions]="{
        visible: $safeNavigationMigration(settings?.toolbar?.pageTypeOptions?.visible()),
        pageType: pageType(),
        options: $safeNavigationMigration(settings?.toolbar?.pageTypeOptions?.options())
      }"
      [size]="toolbarSize()"
      [total]="totalItems()"
    />
  }
</ng-template>

<ng-template #filterEngine>
  @if (settings?.filterEngine?.enabled() && businessProfile()) {
    <iot-platform-ui-filter-engine-v2
      data-cy="feature-master-view-filter-engine"
      [masterView]="$safeNavigationMigration(settings?.masterViewName())"
      [expanded]="filterEngineOpened()"
      [currentFilters]="currentFilters()"
      [currentFavoriteView]="currentFavoriteView()"
      [displayActionButtons]="$safeNavigationMigration(settings?.filterEngine?.displayActionButtons?.())"
      [withFavoriteFilters]="$safeNavigationMigration(settings?.filterEngine?.withFavoriteFilters?.())"
      [suppressOperator]="$safeNavigationMigration(settings?.filterEngine?.suppressOperator?.())"
      [mode]="$safeNavigationMigration(settings?.filterEngine?.mode())"
      (applyFilters)="onApplyFilters($event)"
    />

    @if (settings?.additionalOptions()?.displayWarningMessage?.()) {
      <div class="warning-message fs-12 p-4">{{ $safeNavigationMigration(settings?.additionalOptions()?.displayWarningMessage()) | translate }}</div>
    }
  }
</ng-template>

<ng-template #gridEngines>
  <grid-engine-grid-manager
    data-cy="feature-master-view-grid-manager"
    [masterDetailEnabled]="$safeNavigationMigration(settings?.grid?.masterDetails?.enabled?.())"
    [masterDetailRowAutoHeight]="$safeNavigationMigration(settings?.grid?.masterDetails?.rowAutoHeight?.())"
    [masterDetailCellRenderer]="$safeNavigationMigration(settings?.grid?.masterDetails?.componentRef()?.ref)"
    (dispatchGridEvent)="onDispatchGridEvent($event)"
    (dispatchMasterViewEngineEvent)="onMasterViewEngineEvent($event)"
    (pageChange)="onPageChange($event)"
    (timerValueChanged)="onTimerValueChanged($event)"
    [currentFilters]="currentFilters()"
    [grid]="grid()"
    [gridSort]="gridSort()"
    [autoScroll]="$safeNavigationMigration(settings?.grid?.autoScroll())"
    [hidePaginator]="$safeNavigationMigration(settings?.grid?.hidePaginator())"
    [staticDefinitionType]="$safeNavigationMigration(settings?.grid?.staticDefinitionType())"
    [style]="settings?.grid?.style()"
    [userPermissions]="userPermissions()"
    [visibleNodeId]="selectedRowId()"
    [loading]="loading()"
    fxFlex
  />
</ng-template>

<ng-template #pageContent>
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    @switch (pageType()) {
      @case (ToolbarPageType.GRID) {
        <ng-container *ngTemplateOutlet="gridEngines" />
      }
      @case (ToolbarPageType.MAP) {
        @if (businessProfile()) {
          <iot-platform-maps-map
            data-cy="iot-platform-maps-map"
            fxFlexFill
            (dispatchEvent)="onMapEvent($event)"
            (dispatchMapNavigationEvent)="onMapNavigationEvent($event)"
            [concept]="mapConcept()"
            [displayMode]="mapDisplayMode()"
            [filters]="currentFilters()"
            [zoom]="3"
          />
        }
      }
      @case (ToolbarPageType.DASHBOARD) {
        <iot-platform-feature-dashboards-dashboards-shell
          fxFlexFill
          [dashboard]="$safeNavigationMigration(dashboardsConfiguration?.()?.currentDashboard)"
          [filters]="currentFilters()"
        />
      }
      @default {
        <ng-container *ngTemplateOutlet="gridEngines" />
      }
    }
  </div>
</ng-template>

<ng-template #drawerDetails>
  @if (settings?.drawerDetails?.componentRef(); as componentRef) {
    <ng-container *ngComponentOutlet="componentRef.ref; inputs: componentRef.inputs" />
  }
</ng-template>
